(function () {
  angular
    .module('specsguardApp')
    .controller('widgetProjectAreas', widgetProjectAreas);

  widgetProjectAreas.$inject = ['Labels', '$scope', 'AreaDecoratorFactory', '$window'];

  function widgetProjectAreas (Labels, $scope, AreaDecoratorFactory, $window) {
    const vm = this;
    vm.LABELS = Labels;
    vm.project = $scope.project || $scope.model.project;
    // vm.buildings;

    vm.$onInit = function () {
      displayBuildings(vm.project);
      decorateBuilding();
      clusterCount();
      clusterAreasCount();
    };

    /**
     * Open an area based on the selected building id
     *
     * @param {String} buildingId contains the id of the selected building
     */
    vm.openArea = (buildingId) => {
      $window.location.href = `/project/${vm.project._id}/building/${buildingId}/areas`;
    };

    /**
     * Gather the totalFNO of an area based on the clusters
     *
     * @param {Object} clusters all the clusters in a building
     */
    vm.getTotalFNO = (clusters) =>  {
      return clusters.reduce((memo, cluster) => memo + cluster.getSubTotalFNO(), 0).toFixed(2);
    };

    /**
     * Calculate the total bvo based on the total cluster.FNO * building.ratio
     *
     * @param {Object} clusters all the clusters in a building
     */
    vm.getTotalBVO = (clusters, ratio) => {
      return clusters.reduce((memo, cluster) =>
        memo +  (cluster.getSubTotalFNO() * ratio), 0).toFixed(2);
    };

    /**
     *
     * @param {Object} project scope project object used to fetch all the buildings linked to the project
     */
    const displayBuildings = (project = vm.project) => {
      vm.buildings = project.buildings.map((building) => building.active ? building : '');
    };

    /**
     * clusterCounter is used to count the amount of _ACTIVE_ clusters in a building
     */
    const clusterCount = () => {
      vm.buildings.forEach((building) => {
        building.clusterCount = 0;

        building.clusters.filter((cluster) => {
          if (cluster.active) {
            building.clusterCount++;
          }
        });
        return building;
      });
    };

    /**
     * clusterAreasCount is used to count the amount of _ACTIVE_ cluster areas in a building
     */
    const clusterAreasCount = () => {
      vm.buildings.forEach((building) => {
        building.areasCount = 0;

        building.clusters.forEach((cluster) => {
          cluster.areas.filter((area) => {
            if (area.active) {
              building.areasCount++;
            }
          });
        });

        return building;
      });
    };

    /**
     * each building needs to include the area factories
     * These contain functions like the calculation of the FNO & BVO
     */
    const decorateBuilding = () => {
      vm.buildings.forEach((building) => {
        AreaDecoratorFactory.decorateClustersAndAreas(building.clusters, vm.project);
      });
    };

  }
})();
